import { Link } from 'react-router-dom';
import { company } from '../data/company';

export function SiteFooter() {
  return (
    <footer className="site-footer">
      <div>
        <strong>{company.name}</strong>
        <p>Two pieces of happiness. One for you, one to share.</p>
      </div>
      <nav aria-label="Footer navigation">
        <Link to="/apps">Apps</Link>
        <Link to="/privacy">Privacy</Link>
        <Link to="/terms">Terms</Link>
        <a href={`mailto:${company.contactEmail}`}>Contact</a>
      </nav>
    </footer>
  );
}
